<div class="mui-avatar" [ngClass]="'avatar-size-'+size" [style.background-color]="backgroundColor">
  <ng-container [ngSwitch]="displayType">
    <img *ngSwitchCase="avatarDisplayTypes.AVATAR" src="{{avatarUrl}}" [alt]="name">
    <div *ngSwitchCase="avatarDisplayTypes.INITIALS" class="mui-avatar__content">{{initials}}</div>
    <i *ngSwitchCase="avatarDisplayTypes.ICON" mui-icon class="mui-avatar__content" name="user" font="fa"></i>
  </ng-container>
  <ng-container *ngIf="avatarSubIcon">
    <div class="avatar-sub-icon">
      <i mui-icon [name]="avatarSubIcon" font="fa" class="fas"></i>
    </div>
  </ng-container>
</div>
